<template>
  <div v-if="enabled && displaySelf && cptdIsEligibleForPrecatorio">
    <Announcement
      v-when-visible="triggerEventWhenElementIsVisible"
      class="PrecatorioAnticipationAnnouncementContainer"
      @click="handleClick"
    >
      <AnnouncementContent>
        <AnnouncementContentText>
          <AnnouncementContentTextCaption>
            Precatório federal
          </AnnouncementContentTextCaption>
          <AnnouncementContentTextHeadline>
            Tem <span class="subject">precatório federal</span>? Receba o
            dinheiro agora
          </AnnouncementContentTextHeadline>
        </AnnouncementContentText>
        <AnnouncementContentButton @click="handleClick">
          Antecipar
        </AnnouncementContentButton>
      </AnnouncementContent>
      <AnnouncementImage>
        <LottieAnimation :animation-data="animationJson" />
      </AnnouncementImage>
    </Announcement>
  </div>
</template>

<script>
import Announcement from '~/aasgard/components/cards/announcement/Announcement.vue'
import AnnouncementContent from '~/aasgard/components/cards/announcement/AnnouncementContent.vue'
import AnnouncementContentText from '~/aasgard/components/cards/announcement/AnnouncementContentText.vue'
import AnnouncementContentTextCaption from '~/aasgard/components/cards/announcement/AnnouncementContentTextCaption.vue'
import AnnouncementContentTextHeadline from '~/aasgard/components/cards/announcement/AnnouncementContentTextHeadline.vue'
import AnnouncementImage from '~/aasgard/components/cards/announcement/AnnouncementImage.vue'
import AnnouncementContentButton from '~/aasgard/components/cards/announcement/AnnouncementContentButton.vue'
import { mapActions, mapGetters } from 'vuex'
import whenVisible from '@/aasgard/directives/when-visible'
import LottieAnimation from '~/aasgard/components/lottie/LottieAnimation.vue'
import animationJson from '~/lotties/jb-precatorio-annoucements.json'
import { IncomeSource } from '~/data/common'

export default {
  name: 'PrecatorioAnticipationAnnouncementContainer',
  components: {
    LottieAnimation,
    AnnouncementContentButton,
    AnnouncementImage,
    AnnouncementContentTextHeadline,
    AnnouncementContentTextCaption,
    AnnouncementContentText,
    AnnouncementContent,
    Announcement,
  },
  directives: {
    ...whenVisible,
  },
  emits: ['click'],
  data() {
    return {
      viewIntent: 'antecipacao_precatorio_view',
      clickIntent: 'antecipacao_precatorio_clicked',
      displaySelf:
        localStorage.getItem(`jb.state.antecipacao_precatorio_clicked`) !==
        'true',
      enabled: false,
      animationJson,
    }
  },
  computed: {
    ...mapGetters({
      gtUser: 'user/user/gtUser',
      personaData: 'user/persona/personaData',
    }),
    cptdIsEligibleForPrecatorio() {
      return [IncomeSource.RETIREMENT, IncomeSource.PENSION].includes(
        this.personaData?.finance?.income_source,
      )
    },
  },
  methods: {
    ...mapActions({
      actInsertIntent: 'user/intent/actInsertIntent',
    }),
    async handleClick() {
      await this.actInsertIntent({
        identifier: this.clickIntent,
      })
      localStorage.setItem(`jb.state.antecipacao_precatorio_clicked`, 'true')
      this.redirectUser()
    },
    triggerEventWhenElementIsVisible() {
      this.actInsertIntent({
        identifier: this.viewIntent,
      })
    },
    redirectUser() {
      const url = 'https://contatocidadaniaja.typeform.com/to/SSnMtvNw'
      const searchParams = new URLSearchParams({
        user_id: this.gtUser?.id,
      })
      window.location.href = `${url}?${searchParams}`
      this.displaySelf = false
    },
  },
}
</script>

<style lang="scss">
.PrecatorioAnticipationAnnouncementContainer {
  .subject {
    background: $color-black-high;
    background-clip: inherit;
  }
}
</style>
